import './helpers.js';

jQuery(document).ready(function($) {
    // header main menu toggle
    $('body').on('click', '.site-header--menu-toggle .icon', function(e) {
        e.preventDefault();
        const $this = $(this);
        $('body').toggleClass('menu-open');
        $this.toggleClass('open');

        // if open then scroll to top
        if($this.hasClass('open')) {
            console.log('animate');
            $('html, body').animate({
                scrollTop: 0
            }, 400);
        }
    })

    new einsteinSwiper('.more-stories-swiper.swiper', {
        spaceBetween: 16,
        loop: true,
        slidesPerView: "auto",
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        // spacebetween: 16 for mobile,
        breakpoints: {
            768: {
                spaceBetween: 32,
            }
        }
    });

    new einsteinSwiper('.xl-posts-swiper.swiper', {
        spaceBetween: 16,
        loop: true,
        slidesPerView: "auto",
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
    });
});